import { render, staticRenderFns } from "./TicketRequestListTableZone.vue?vue&type=template&id=636c3d20"
import script from "./TicketRequestListTableZone.vue?vue&type=script&lang=js"
export * from "./TicketRequestListTableZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports